import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    constructor(
    ) 
    { }

    public appTitle!: string;
    public imageMenuCode!: number;
    public loginTheme!: string | null;
}
